import {FC} from 'react';

import {DevicesList} from '../../../components/Dictionaries/Devices';

import styles from './DeviceModels.module.scss';

const DevicesPage: FC = () => {
  return (
    <div className={styles.devices}>
      <DevicesList />
    </div>
  );
};

export default DevicesPage;
